module.exports = __webpack_public_path__ + "static/img/tab1Big.70ad891.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/tab1Big.png
// module id = 0qXK
// module chunks = 1